import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Division } from '../../models/division';
import { DivisionService } from '../../services/division.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';
import { State } from '../../models/state';
import { StateService } from '../../services/state.service';
import { Region } from '../../models/region';
import { RegionService } from '../../services/region.service';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDivision: PageHeader;
  entity: Division = new Division();
  selectedDivision: Division = new Division();
  editingEntity: Division = new Division();
  divisions: any;
  divisionColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  zone: Array<Zone> = [];
  selectedZone: any;
  state: Array<State> = [];
  selected_state: Array<State> = [];
  selectedState: any;
  region: Array<Region> = [];
  selectedRegion: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _divisionService: DivisionService,
    private _regionService: RegionService,
    private _companyService: CompanyService,
    private _zoneService: ZoneService,
    private _stateService: StateService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerDivision = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.divisions = [];
    this.getAllDivision();
  }
  ngAfterViewInit(): void {
    this.divisionColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "DivisionName", title: 'Area', filter: true, sortable: true, width: 100 },
      { field: "DivisionCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Area Head', filter: true, sortable: true, width: 100 },
      { field: "DivisionMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
      { field: "DivisionPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true },
      // { field: "ZoneName", title: 'Zone', filter: true, sortable: true },
      // { field: "StateName", title: 'State', filter: true, sortable: true },
      { field: "RegionName", title: 'Region', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }


  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._divisionService.getAllDivisions('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Division>) => {
      this.divisions = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  // getAllZone(filter: string) {
  //   this._zoneService.getAllZones(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Zone>) => {
  //     this.zone = data;
  //   })
  // }
  getAllState(filter: string) {
    this._stateService.getAllStates(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<State>) => {
      this.state = data;
    })
  }
  getAllRegion(filter: string) {
    this._regionService.getAllRegions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Region>) => {
      this.region = data;
      // this.Regionchanged('')
      // this.selectedZone = { Zone_Id: this.region[0].Zone_Id, Zone_Name: this.region[0].ZoneName };
      // this.selectedState = { State_Id: this.region[0].State_Id, Zone_Name: this.region[0].StateName };

    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._divisionService.getAllDivisions(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((divisions: Array<Division>) => {
        this.divisions = {
          data: divisions,
          total: divisions[0] ? divisions[0].TotalCount : 0
        }
      });
    }
  }
  getAllDivision() {
    this._divisionService.getAllDivisions('', Number(this.defaultPageSize), 1, 0, 0).subscribe((divisions: Array<Division>) => {
      this.divisions = {
        data: divisions,
        total: divisions[0] ? divisions[0].TotalCount : 0
      }
    })
  };
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._divisionService.deleteDivision(this.selectedDivision.Division_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDivision();
            this.getAllDivision();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerDivision = new PageHeader();
    headerDivision.PageCaption = "Area";
    headerDivision.IconClass = "bi bi-shield-shaded";
    return headerDivision;
  }

  deleteDivision(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDivision.Division_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Area",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDivision(event: any) {
    this.listView = false;
    this.clearDivision();
    this.getAllCompany('');
    this.getAllEmployees('');
    // this.getAllState('');

    // this.getAllZone('');
    this.getAllRegion('');
    this.formCaption = "Add Area";
  }

  editDivision(event: any): void {
    if (event.seletedRows[0]) {
      this._divisionService.viewDivision(event.seletedRows[0]).subscribe((divisions: Array<Division>) => {
        let editEnity = divisions[0] ? divisions[0] : new Division();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedZone = { Zone_Id: editEnity.Zone_Id, Zone_Name: editEnity.ZoneName };
          this.selectedState = { State_Id: editEnity.State_Id, State_Name: editEnity.StateName };
          this.selectedRegion = { Region_Id: editEnity.Region_Id, Region_Name: editEnity.RegionName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Area";
          this.getAllCompany('');
          this.getAllEmployees('');
          // this.getAllZone('');
          // this.getAllState('');
          this.getAllRegion('');
          this.getAllStatesbyRegion('');
          this.getAllZone(editEnity.State_Id);

          this.entity.EntityMetaData = [
            { FieldName: 'DivisionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
            //{ FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },      
            //{ FieldName: 'Region_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region is required' },   
          ];
        }
      });
    }
  }

  Regionchanged(region: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };

    if (region) {
      // this.getAllState(this.entity.State_Id);
      this.getAllStatesbyRegion(region.Region_Id);
      //this.getAllZone('');
    }
  }

  getAllStatesbyRegion(filter: string) {
    this._stateService.getAllStatesbyRegion(this.entity.Region_Id).subscribe((data: Array<State>) => {
      this.state = data;
    })
    //this.selectedZone = { Zone_Id: this.state[0].Zone_Id, Zone_Name: this.state[0].ZoneName };
    //this.selectedState = { State_Id: this.state[0].State_Id, StateName: this.state[0].StateName };
    // this.getAllZone('');
    // this.getAllState('');
  }
  Statechanged(state: any) {
    this.zone = [];
    this.entity.Zone_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    if (state) {
      // this.getAllState(this.entity.State_Id);
      this.getAllZone(this.entity.State_Id);
    }
  }
  getAllZone(filter: string) {

    this._zoneService.getAllStatesbyzone(filter).subscribe((data: Array<Zone>) => {
      this.zone = data;
    })
    // this.selectedZone = { Zone_Id: this.zone[0].Zone_Id, Zone_Name: this.zone[0].Zone_Id };

  }
  // getAllZone(filter: string) {
  //   this._zoneService.getAllZones(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Zone>) => {
  //     this.zone = data;
  //   })
  // }
  save(event: any): void {
    if (parseInt(this.entity.Code) == 0) {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._divisionService.checkDuplication(this.entity.Division_Id, this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Area Code Already exists');
          this.saveDisabled = false;
          return false
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
            return
          }
          else {
            if (this.entity.EmailId != "") {
              // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; commented on 04-06-2024 by jessil for #I238
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
              if (this.emailcheck === false) {
                this.notification.showWarning("Email not valid");
                this.saveDisabled = false;
                return false;
              }
              else {
                this._divisionService.checkEmail(this.entity.EmailId, this.entity.Division_Id).subscribe((response) => {
                  if (response.Success == false) {
                    this.notification.showWarning("Email already exists");
                    this.saveDisabled = false;
                    return
                  }
                  else {
                    this._divisionService.saveDivision(this.entity).subscribe(() => {
                      if (this.entity.Division_Id == '00000000-0000-0000-0000-000000000000') {
                        this.notification.showSuccess('Saved Successfully');
                      }
                      else {
                        this.notification.showSuccess('Updated Successfully');
                      }
                      this.listView = true;
                      this.clearDivision();
                      this.getAllDivision();
                    });
                  }
                });
              }

            }
            else {
              this._divisionService.saveDivision(this.entity).subscribe(() => {
                if (this.entity.Division_Id == '00000000-0000-0000-0000-000000000000') {
                  this.notification.showSuccess('Saved Successfully');
                }
                else {
                  this.notification.showSuccess('Updated Successfully');
                }
                this.listView = true;
                this.clearDivision();
                this.getAllDivision();
              });
            }
            
          }
          return
        }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  goToBackTab(): void {

    this.listView = true;

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllDivision();
  }

  refreshDivisions(event: any): void {
    this.divisions = [];
    this.getAllDivision();
  }

  clearDivision(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.selectedZone = {};
    this.selectedState = {};
    this.selectedRegion = {};
    this.entity = new Division();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Division_Id = dataItem.Division_Id;
    this.details = [];
    this._divisionService.viewDivision(this.entity.Division_Id).subscribe((divisions: Array<Division>) => {
      this.opened = true;
      this.details = divisions[0];
    })
  }
}
